/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-11-06 16:30:05
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-07 14:35:25
 * @FilePath: \senlan-ai-ui\src\api\modules\login.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import http from '../index.ts'

// 登录接口
export const loginApi = (params) => {
  return http.post('/login', params)
}
export const loginCodeApi = (params) => {
  return http.post('/login-code', params)
}
export const logoutApi = () => {
  return http.get('/logout')
}
export const tempLoginApi = (params) => {
  return http.post('/generate-temporary-token', params)
}
export const testAuthApi = () => {
  return http.get('/operate-limit')
}
export const getCodeApi = (phone: string) => {
  return http.get(`/send/code/${phone}`)
}